import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { MessageSquare, Globe, Network } from 'lucide-react'
import { QuickQuestion } from './components/QuickQuestion'
import { BulkEnquiry } from './components/BulkEnquiry'
import { CascadeDesign } from './components/CascadeDesign'

// ─── Main Component ────────────────────────────────────────────────────

export function MatchRateTool() {
  const [searchParams] = useSearchParams()
  const defaultMode = searchParams.has('question') ? 'questions' : searchParams.has('assessment') ? 'bulk' : 'questions'
  const [mode, setMode] = useState<'questions' | 'bulk' | 'cascade'>(defaultMode)

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-[var(--text-primary)]">Match Rate Enquiry</h2>
          <p className="text-xs text-[var(--text-muted)] mt-0.5">
            AI-powered analysis of FrankieOne match rates for prospect countries and rulesets
          </p>
        </div>
      </div>

      {/* Mode Toggle */}
      <div className="flex gap-2">
        <button
          onClick={() => setMode('questions')}
          className={`flex items-center gap-2 px-4 py-2 text-sm rounded-lg transition-colors ${
            mode === 'questions' ? 'bg-violet-600 text-white' : 'bg-[var(--bg-tertiary)] text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)]'
          }`}
        >
          <MessageSquare size={14} /> Quick Questions
        </button>
        <button
          onClick={() => setMode('bulk')}
          className={`flex items-center gap-2 px-4 py-2 text-sm rounded-lg transition-colors ${
            mode === 'bulk' ? 'bg-violet-600 text-white' : 'bg-[var(--bg-tertiary)] text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)]'
          }`}
        >
          <Globe size={14} /> Bulk Assessment
        </button>
        <button
          onClick={() => setMode('cascade')}
          className={`flex items-center gap-2 px-4 py-2 text-sm rounded-lg transition-colors ${
            mode === 'cascade' ? 'bg-violet-600 text-white' : 'bg-[var(--bg-tertiary)] text-[var(--text-secondary)] hover:bg-[var(--bg-secondary)]'
          }`}
        >
          <Network size={14} /> Cascade Design
        </button>
      </div>

      {/* Quick Questions Mode */}
      {mode === 'questions' && <QuickQuestion />}

      {/* Bulk Assessment Mode */}
      {mode === 'bulk' && <BulkEnquiry />}

      {/* Cascade Design Mode */}
      {mode === 'cascade' && <CascadeDesign />}
    </div>
  )
}
